import { Config } from "../../types";
import Verse from "./Verse";
import VerseSettings from "./VerseSettings";
import VerseTypographySettings from "./VerseTypographySettings";

const config: Config = {
  key: "widget/luminaverse",
  name: "Bible Verse",
  description: "Fetch a Bible verse.",
  dashboardComponent: Verse,
  settingsComponent: VerseSettings,
  managesOwnTypography: true,
  typographySettingsComponent: VerseTypographySettings,
};

export default config;
